module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAMAAACtdX32AAAAY1BMVEXOESbPFiXPFibQFybQGyXRGyXRHSXSIiXTIyTUJyTbRyHcTSHgXCDjZx/kbx/lbx7sjBzsjRzskBvskBztkxvulRvyqxnzqhnzqhr3vRf3vRj5xRf6yhb6yxb7zhb7zhf80RaGS/nYAAAAZElEQVQYGc3BRw6AMAwEwIVQQu+9xP9/JRbiBCZHxAw+pDVsihw2wwgLfzc+RE7AUqI0YA7uVL3SZW0UnuKFTksMUdgT60O8qIiVeOFuNM20uZAlpvW81iSQdRlY1kEW4RThHw7stwaBtv/S0QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/vn.png
// module id = 957
// module chunks = 0